<template>
  <div v-if="pageNotFound" class="house-not-found">Дом с таким номером не найден</div>
  <div v-else class="house-info content-padding">
    <div class="house-info-header">
      <h2 class="house-info-address">Паспорт дома</h2>
      <button class="btn" @click="showAddElementModal = true"><span class="ic-add"></span>Добавить элемент</button>
    </div>

    <div class="house-info-content row">
      <div class="house-info-left-side col-12 col-md-8">
        <Ymap :markers="marker" class="house-info-map"></Ymap>
        <div class="col house-info-el d-md-block d-none">
          <div class="input-with-cross">
            <label for="search-input" class="ic-search"></label>
            <input id="search-input" v-model="searchValue" type="text" class="form-control" placeholder="Поиск элемента">
            <span v-if="searchValue" class="ic-cross" @click="searchValue = ''"></span>
          </div>
        </div>
      </div>
      <div class="house-info-right-side col-12 col-md-4">
        <div class="house-numbers text-secondary">
          <div class="col">Адрес: <span>{{ address }}</span></div>
          <div class="col">Почтовый индекс: <span>{{ zip_code }}</span></div>
          <div class="col">Год постройки: <span>{{ year }}</span></div>
          <div class="col">Кадастровый номер: <span>{{ kadastr }}</span></div>
        </div>
      </div>
    </div>

    <div class="col house-info-el d-md-none">
      <div class="input-with-cross">
        <label for="search-input-md" class="ic-search"></label>
        <input id="search-input-md" v-model="searchValue" type="text" class="form-control" placeholder="Поиск элемента">
        <span v-if="searchValue" class="ic-cross" @click="searchValue = ''"></span>
      </div>
    </div>
    <Loader v-if="isHouseElementsLoading" class="loader"></Loader>

    <div class="house-info-el-not-found" v-else-if="getCurrentHouseElements.length === 0">Элементы не найдены</div>

    <elements-list class="filtered-house-elements" v-else-if="searchValue" :elements="getCurrentHouseElements"
                   @edit="openEditElementModal" @delete="openDeleteElementModal" :with-buttons="true"/>

    <accordion-elements v-else :elements="getCurrentHouseElements">
      <template v-slot:title="{element}">
        {{ element.name }}
        <span class="ic-archive"></span>
      </template>
      <template v-slot:body="{element}">
        <elements-list :with-buttons="true" :elements="element.elements" @edit="openEditElementModal"
                       @delete="openDeleteElementModal"/>
      </template>
    </accordion-elements>

  </div>

  <Modal class="modal-xl" v-model="showAddElementModal">
    <template v-slot:title>
      Добавить элемент
    </template>
    <template v-slot:body>
      <add-element v-model="showAddElementModal"/>
    </template>

  </Modal>

  <Modal v-model="showEditElementModal">
    <template v-slot:title>
      Редактировать элемент
    </template>
    <template v-slot:body>
      <edit-element v-model="showEditElementModal"/>
    </template>
  </Modal>

  <Modal v-model="showDeleteElementModal" class="modal-sm">
    <template v-slot:title>
      Удалить элемент?
    </template>
    <template v-slot:body>
      <div class="position-relative">
        <transition name="fade">
          <div v-if="isDeleteElementLoading" class="common-shadow-loader">
            <Loader/>
          </div>
        </transition>
        <div class="delete-buttons">
          <button class="btn btn-primary" @click="clickDeleteElementButton">Да</button>
          <button class="btn btn-primary" @click="showDeleteElementModal = false">Нет</button>
        </div>
      </div>


    </template>
  </Modal>

</template>

<script>

import Ymap from "@/components/common/Ymap";
import {useRoute} from "vue-router";
import UseCrudElements from "@/composables/crudElements/UseCrudElements";
import UseCrudHouse from "@/composables/crudHouse/UseCrudHouse";
import Modal from "@/components/common/Modal";
import AddElement from "@/components/crudElements/AddElement";
import Loader from "@/components/common/Loader";
import EditElement from "@/components/crudElements/EditElement";
import ElementsList from "@/components/crudElements/ElementsList";
import AccordionElements from "@/components/common/AccordionElements";

export default {
  name: 'HouseElements',
  components: {AccordionElements, ElementsList, EditElement, Loader, AddElement, Modal, Ymap},
  setup() {
    const route = useRoute()
    return {
      ...UseCrudHouse(route.params.houseId),
      ...UseCrudElements()
    }
  },
  data() {
    return {
      showAddElementModal: false,
      showEditElementModal: false,
      showDeleteElementModal: false
    }
  },
  methods: {
    openEditElementModal(elementId) {
      this.showEditElementModal = true
      this.setSelectedElement(elementId)
    },
    openDeleteElementModal(elementId) {
      this.showDeleteElementModal = true
      this.setSelectedElement(elementId)
    },
    clickDeleteElementButton() {
      this.deleteElement()
        .then(() => this.showDeleteElementModal = false)
    }
  }
}
</script>

<style lang="scss" scoped>

.house-info {

  .house-info-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .btn {
      display: flex;
      align-items: center;
      margin-left: .9em;
      color: var(--common-text-color);
      padding: 0;

      span {
        color: var(--common-button);
        margin-right: .4em;
      }
    }
  }

  .house-info-content {
    margin-bottom: 2em;

    div.house-info-left-side {
      border-right: 1px solid var(--common-text);
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .col {
        flex-grow: 0;
      }
    }
  }

  .house-numbers {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    height: 100%;

    .col {
      flex-grow: 0;
    }

    span {
      border-radius: 20px;
      border: 1px solid var(--common-text);
      padding: 0.9rem 1.2rem;
      display: block;
      width: 100%;
      color: var(--common-text-color);
    }
  }

  .house-info-map {
    height: 100%;
    margin: 1em 0;
  }

  .house-info-el {
    margin-top: 20px;
    display: flex;

    button {
      margin-right: 20px;
      white-space: nowrap;
    }

    .input-with-cross {
      position: relative;
      width: 100%;

      input {
        padding: 0.9rem 30px 0.9rem 50px;
        font-size: var(--bs-body-font-size);
      }

      .ic-search {
        left: 14px;
        right: initial;

        &:hover {
          color: var(--default-icon-color);
          cursor: default;
        }
      }

      span, label {
        position: absolute;
        right: 7px;
        top: 9px;
        cursor: pointer;
      }
    }
  }

  .filtered-house-elements {
    background-color: transparent;
    padding: 0.5rem 2rem;
    border-radius: 10px;
  }

  .house-info-el-not-found {
    text-align: center;
    padding: 10px 0;
  }

  .loader {
    margin-top: 1em;
  }

}

.delete-buttons {
  display: flex;
  flex-direction: column;

  button {
    margin-top: 5px;
    width: 100%;
  }
}

.ic-archive {
  color: var(--common-button);
}

@media (min-width: 768px) {
  .house-info {
    .house-info-content {

      div.house-info-left-side {
        padding-right: 1.5em;
      }

      div.house-info-right-side {
        padding-left: 1.5em;
      }
    }
  }

}

@media (max-width: 767px) {
  .house-info {
    .house-info-content {
      margin-bottom: 1em;

      div.house-info-left-side {
        border-right: none;
      }
    }
  }
}


@media (max-width: 600px) {
  .house-info {
    .house-info-header {
      flex-direction: column;

      button.btn {
        align-self: flex-start;
        margin-left: 0;
      }
    }
  }
}

</style>
